import ReceiveCommon from "../ReceiveCommon";

function ReceiveOptions({ isReceive, setIsReceive }) {
  return (
    <ReceiveCommon
      isReceiveModalOpen={isReceive}
      setIsReceiveModalOpen={setIsReceive}
      directionToOpen={"up"}
      customClass="options-modal-container"
      qrSize={410}
      isFromBrowser={true}
    />
  );
}

export default ReceiveOptions;
